import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { useAuth } from './AuthContext';
import { DAILY_WINS_EVENT, emptyDailyWinsRecord, readDailyWins } from '../utils/dailyWins';
import { todayYmdInOrgTimeZone } from '../utils/organizationalTime';

const DailyWinsContext = createContext(null);

export function DailyWinsProvider({ children }) {
  const { user } = useAuth();
  const uid = user?.uid || '';
  const [dayKey, setDayKey] = useState(todayYmdInOrgTimeZone);
  const [record, setRecord] = useState(() => emptyDailyWinsRecord(uid));

  useEffect(() => {
    const refresh = () => {
      const nextDay = todayYmdInOrgTimeZone();
      setDayKey(nextDay);
      setRecord(uid ? readDailyWins(uid, nextDay) : emptyDailyWinsRecord('', nextDay));
    };
    refresh();
    const timer = setInterval(refresh, 60000);
    const onUpdate = (event) => {
      if (event.detail?.uid === uid && event.detail?.ymd === todayYmdInOrgTimeZone()) {
        setRecord(event.detail);
      }
    };
    window.addEventListener(DAILY_WINS_EVENT, onUpdate);
    return () => {
      clearInterval(timer);
      window.removeEventListener(DAILY_WINS_EVENT, onUpdate);
    };
  }, [uid]);

  const value = useMemo(
    () => ({ dayKey, wins: record.counters, record }),
    [dayKey, record],
  );

  return <DailyWinsContext.Provider value={value}>{children}</DailyWinsContext.Provider>;
}

export function useDailyWins() {
  const value = useContext(DailyWinsContext);
  if (!value) throw new Error('useDailyWins must be used within DailyWinsProvider');
  return value;
}

